// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"bee13523","453":"d724e79d"}[chunkId] + ".chunk.js";
};